var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"Button",class:['Button-'+_vm.type,'Button-'+_vm.size]},[_c('button',{attrs:{"disabled":_vm.disabled,"type":_vm.mode},on:{"click":function($event){return _vm.Click($event)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }